module.exports = __webpack_public_path__ + "img/scene2-17.92337c91.jpg";